/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
Coded by www.creative-tim.com
 =========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.
  Once you add a new route on this file it will be visible automatically on
  the Sidenav.
  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/
import Dashboard from "layouts/dashboard";
import Orders from "layouts/order";
import Exposures from "layouts/exposure";
import Transactions from "layouts/transactions";
import TransactionsNew from "layouts/transactionsNew";
import BatteryInfos from "layouts/battery";
import WarehousesRealtime from "layouts/warehousesRealtime";
import KeyMetrics from "layouts/keyMetrics";
import SignIn from "layouts/authentication/sign-in";
import AgentManagements from "layouts/agent";
import Credits from "layouts/credit";
import ResetPassword from "layouts/authentication/reset-password";
import ForgetPassword from "layouts/authentication/forget-password";
import SignOut from "layouts/authentication/sign-out";
import PrivateRoute from "components/PrivateRoute";
// @mui icons
import Icon from "@mui/material/Icon";
import CouponManagement from "layouts/couponManagement";
import Products from "layouts/products";
import MembershipAnalysis from "layouts/membershipAnalysis";
import MembershipManagement from "layouts/membershipManagement";
import UserManagement from "layouts/userManagement";
import UserManagementRoleEditor from "layouts/userManagementRoleEditor";
import PermissionManagement from "layouts/permissionManagement";
import MarketingDataAnalysis from "layouts/marketDataAnalysis";
import Invoices from "layouts/invoice";
import BillingReconcile from "layouts/billingReconcile";
import Warehouses from "layouts/warehouse";
import TaskReview from "layouts/taskReview";
import AbnormalOrders from "layouts/abnormalOrders";
import EmployeeManagement from "layouts/employee";
import Venues from "layouts/venues";
import MachineBootstrapSetup from "layouts/machineBootstrapSetup";
import Manufacturer from "layouts/manufacturer";
import Tables from "layouts/tables";
import { routeConfig } from "routeConfig";

const COMPONENTS = {
  Dashboard,
  Orders,
  Exposures,
  Transactions,
  TransactionsNew,
  BatteryInfos,
  WarehousesRealtime,
  KeyMetrics,
  SignIn,
  AgentManagements,
  Credits,
  ResetPassword,
  ForgetPassword,
  SignOut,
  CouponManagement,
  Products,
  MembershipAnalysis,
  MembershipManagement,
  UserManagement,
  UserManagementRoleEditor,
  PermissionManagement,
  MarketingDataAnalysis,
  Invoices,
  BillingReconcile,
  Warehouses,
  TaskReview,
  AbnormalOrders,
  EmployeeManagement,
  Venues,
  MachineBootstrapSetup,
  Manufacturer,
  Tables,
};

const routes = routeConfig.map(({ iconName, componentKey, ...route }) => {
  const Component = COMPONENTS[componentKey];
  const wrappedComponent =
    componentKey === "SignIn" ||
    componentKey === "ResetPassword" ||
    componentKey === "ForgetPassword" ||
    componentKey === "SignOut" ? (
      <Component />
    ) : (
      <PrivateRoute component={Component} />
    );

  return {
    ...route,
    icon: <Icon fontSize="small">{iconName}</Icon>,
    component: wrappedComponent,
  };
});

export default routes;
